import { mixed, object, string } from "yup";
import { FormStore } from "@modules/formx";
import { pick } from "@bonliva-crm/common";
import { store } from "@store";
import {
  CallListEditor_CallListFragment,
  CallListEditor_Create,
  CallListEditor_Get,
  CallListEditor_Update,
  GetMyProfile
} from "@graphql";
import { CallListEditorProps } from "./CallListEditor";

type FormData = CallListEditor_CallListFragment;

export class CallListEditorStore extends FormStore<FormData> {
  get isNew() {
    return !this.opts.id;
  }

  constructor(public readonly opts: CallListEditorProps) {
    super({
      schema: object<FormData>({
        _id: mixed(),
        name: string().required("Missing name") // todo: localize
      })
    });

    if (opts.id) {
      CallListEditor_Get.func({ id: opts.id })
        .then(({ data }) => {
          this.reset(pick(data.callListById.callList, "_id", "name"));
        })
        .catch((e) => {
          store().snackbars.error(`Cannot fetch call list\nReason: ${e}`);
        });
    }
  }

  onSubmit = () => {
    const promise = this.opts.id
      ? CallListEditor_Update.func(
          { id: this.opts.id, newName: this.values.name },
          {
            refetchQueries: [GetMyProfile.OperationName]
          }
        )
      : CallListEditor_Create.func(
          {
            listType: this.opts.listType,
            name: this.values.name,
            nodes: [this.opts.node],
            type: this.opts.type
          },
          {
            refetchQueries: [GetMyProfile.OperationName],
            awaitRefetchQueries: true
          }
        );

    return promise
      .then(() => {
        store().snackbars.success("OK");
        this.opts.onAdded();
        this.opts.onClose();
      })
      .catch((e) => {
        store().snackbars.error(`Cannot submit form\nReason: ${e}`);
      });
  };
}
